import { render, staticRenderFns } from "./StorageDetail.vue?vue&type=template&id=1ef0f0f1"
import script from "./StorageDetail.vue?vue&type=script&lang=js"
export * from "./StorageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports